/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_DateInputs */

const en_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const fr_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const de_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

const it_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const ru_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата`)
};

const es_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha`)
};

const zh_cn2_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期`)
};

const ja_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付`)
};

const hi_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख`)
};

const pt_pt2_invoice_date = /** @type {(inputs: Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Invoice_DateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const invoice_date = /** @type {((inputs?: Invoice_DateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_DateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_invoice_date(inputs)
	if (locale === "de") return de_invoice_date(inputs)
	if (locale === "it") return it_invoice_date(inputs)
	if (locale === "ru") return ru_invoice_date(inputs)
	if (locale === "es") return es_invoice_date(inputs)
	if (locale === "zh-CN") return zh_cn2_invoice_date(inputs)
	if (locale === "ja") return ja_invoice_date(inputs)
	if (locale === "hi") return hi_invoice_date(inputs)
	if (locale === "pt-PT") return pt_pt2_invoice_date(inputs)
	return en_invoice_date(inputs)
});